"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BEST_OFFERS_SUB_LINK = exports.BEST_OFFERS_SUB_HEADLINE = exports.BEST_OFFERS_SUBMENU_MOBILE = exports.BEST_OFFERS_SUBMENU = void 0;
const BEST_OFFERS_SUBMENU = exports.BEST_OFFERS_SUBMENU = 'best-offers-sub-menu';
const BEST_OFFERS_SUB_HEADLINE = exports.BEST_OFFERS_SUB_HEADLINE = 'best-offers-sub-menu-headline';
const BEST_OFFERS_SUB_LINK = exports.BEST_OFFERS_SUB_LINK = 'best-offers-sub-menu-link';
const BEST_OFFERS_SUBMENU_MOBILE = exports.BEST_OFFERS_SUBMENU_MOBILE = 'best-offers-sub-menu-mobile';